import React from "react";
import PageHeader from "../../components/PageHeader";
import AppUserListComponent from "../../components/AppUsers/AppUserList";

class AppUserList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="App Users"
                            Breadcrumb={[
                                { name: "App Users", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <AppUserListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AppUserList;
